import { UploadReportsFormData } from './UploadReportsFormData.types';
import { FetchApi } from '../../api/ApiFetch/ApiFetch';
import { HTTPMethod } from '../../api/ApiFetch/HTTPMethod.types';
import { ServiceType } from '../../api/ApiFetch/ServiceType.types';
import { ApiUrls } from '../../api/ApiConstants/ApiUrls';
import { CreateTextResponse, ResponseData } from '../../api/ApiFetch/ApiResponse';

export async function uploadReportsFormData(params: UploadReportsFormData): Promise<Response> {
	 const formData = new FormData();
	 formData.append('clientId', params.clientId); 
	 formData.append('importId', params.importId.toString()); 
	 formData.append('zipFileToUpload', params.file); 

	 const response = await FetchApi({
		 endpoint: ApiUrls.UPLOAD_ENORMOUS_ETL_DATA.replace('{jobId}', params.jobId.toString()),
		 method: HTTPMethod.Post,
		 apiType: ServiceType.Import,
		 body: formData,
	 });
	 return response;
}

export async function downloadEnormousZipFile(jobId: string, importId: string): Promise<Response> {
	 const response = await FetchApi({
		 endpoint: ApiUrls.DOWNLOAD_ENORMOUS_ZIP_FILE.replace('{jobId}', jobId).replace('{importId}', importId),
		 method: HTTPMethod.Get,
		 apiType: ServiceType.Import,
	 });
	 return response;
}

export async function getEnormousUploadDetails(): Promise<ResponseData> {
	 const response = await FetchApi({
		 endpoint: ApiUrls.GET_ENORMOUS_UPLOAD_DETAILS,
		 method: HTTPMethod.Get,
		 apiType: ServiceType.Import,
	 }).catch((error) => {
		 return error;
	 });
	 return CreateTextResponse(response);
}
